import React from 'react';
import { connect } from 'react-redux';

import Correo from './correo.cmpt';

const mapState = (state) => {
    return {
        loading: state.global.loading,
        paso: state.registro.paso
    };
}

const mapDispatch = (dispatch) => {
    return {
        pasoCompleto: () => {
            dispatch({ "type": "REGISTRO_COMPLETO", completo: true });
        }
    }
}

class Flujo extends React.Component {
    
    componentWillMount = () => {
        this.props.pasoCompleto();
    }
    
    render() {
        return (
            <div className="gnp-registro">
                <Correo />
            </div>
        )
    }
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/gnp-registro-completo/flujo.cmpt.js